import { environment } from "src/environments/environment";

export class AppUrl {
    //public static liveApiBaseURL = "https://afriautos.com:8443";
    //public static localApiBaseURL = "http://127.0.0.1:8000"; //localhost
    //public static localApiBaseURL = "http://10.0.2.2:8096"; //emulator
    //public static localApiBaseURL = "http://localhost:8096"; //browser
    //public static localApiBaseURL = "http://localhost:8097"; //docker
    //public static localApiBaseURL = "http://192.168.1.183:8096"; //device
  
    //public static apiBaseURL = this.localApiBaseURL;
    //public static apiBaseURL = this.liveApiBaseURL;

    ///public static apiBaseURL = this.localApiBaseURL;

    public static apiBaseURL = environment.apiBaseUrl
  

    // auth
    public static login = this.apiBaseURL+"/auth/login"; 
    public static signup = this.apiBaseURL+"/auth/signup/dealer";
    public static logout = this.apiBaseURL+"/auth/logout";
    public static recoverPassword = this.apiBaseURL+"/auth/password/recover";
    public static updatePassword = this.apiBaseURL+"/auth/password/update";
  

    // dealer
    public static dealer = this.apiBaseURL+"/dealer";
    public static dealerFavs = this.apiBaseURL+"/dealer/fav";
    public static dealerReviews = this.apiBaseURL+"/dealer/reviews";
    public static dealerContracts = this.apiBaseURL+"/dealer/contracts";

    public static dealerSearchPreview = this.apiBaseURL+"/dealer/search/preview";
    public static dealerSearchPublic = this.apiBaseURL+"/dealer/search/providers-for-public";
    
    public static dealerSearchOwners = this.apiBaseURL+"/dealer/search/owners-for-provider";
    public static dealerSearchProviders = this.apiBaseURL+"/dealer/search/providers-for-owner";
    
    public static sellerDetails = this.apiBaseURL+"/dealer/seller";

    public static dealerMenu = this.apiBaseURL+"/dealer/menu";

    // carref
    public static carref = this.apiBaseURL+"/carref"; 


    // car
    public static allCars = this.apiBaseURL+"/car/all";
    public static allMyCars = this.apiBaseURL+"/car/my-park";
    public static carDetails = this.apiBaseURL+"/car";

    public static carBusinessLine = this.apiBaseURL+"/car/business-line";

    //public static carAlerts = this.apiBaseURL+"/car/alerts";
    

    
    // buy
    public static buyProviderOffers= this.apiBaseURL+"/buy/provider-offers";

    public static buyProposals = this.apiBaseURL+"/buy/proposals";
 
    public static buySearchCarPreviews = this.apiBaseURL+"/buy/search/car-previews";
    //public static buySearchCarDetails = this.apiBaseURL+"/api/buy/cars/criteria/preview";  // Elasticsearch

    public static buySearchCarBriefs = this.apiBaseURL+"/buy/search/car-briefs";

    public static buySearchCarDetails = this.apiBaseURL+"/buy/search/car-details";
    //public static buySearchCarDetails = this.apiBaseURL+"/api/buy/cars/criteria";  // Elasticsearch

    public static buyCustomerData = this.apiBaseURL+"/buy/customer";
    //public static buyCustomerDataFavorites = this.apiBaseURL+"/buy/customer-data/favorites";

    public static buyMenu = this.apiBaseURL+"/buy/offers/menu";

    
    // rent  
    public static rentProviderOffers= this.apiBaseURL+"/rent/provider-offers";
  
    public static rentBookings = this.apiBaseURL+"/rent/bookings";

    public static rentSearchCarPreviews = this.apiBaseURL+"/rent/search/car-previews";
    //public static rentSearchCarPreviews = this.apiBaseURL+"/api/rent/cars/criteria/preview";   //Elasticsearch

    public static rentSearchCarBriefs = this.apiBaseURL+"/rent/search/car-briefs";
    
    public static rentSearchCarDetails = this.apiBaseURL+"/rent/search/car-details";
    //public static rentSearchCarDetails = this.apiBaseURL+"/api/rent/cars/criteria";   //Elasticsearch

    public static rentCustomerData = this.apiBaseURL+"/rent/customer";
    //public static rentCustomerDataFavorites = this.apiBaseURL+"/rent/customer-data/favorites";


    // keep
    public static carPark = this.apiBaseURL+"/keep/park";

    public static keepProviderOffers= this.apiBaseURL+"/keep/provider-offers";

    public static keepJobs = this.apiBaseURL+"/keep/jobs";

    public static keepPostings = this.apiBaseURL+"/keep/postings";

    public static jobSearchPreview = this.apiBaseURL+"/keep/search/jobs/preview";
    public static jobSearch = this.apiBaseURL+"/keep/search/jobs/details";

    public static keepCustomerData = this.apiBaseURL+"/keep/customer";


    // common
    public static conversations = this.apiBaseURL+"/common/conversations";
    public static appointments = this.apiBaseURL+"/common/appointments";

    public static carFiles = this.apiBaseURL+"/files/cars";

    // others
    public static allOffers = this.apiBaseURL+"/offer/all";
    public static allMyOffers = this.apiBaseURL+"/offer/allmy";
    public static offerDetails = this.apiBaseURL+"/offer";
    
  }
  